/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { MarkdownEditor } from "@octopusdeploy/design-system-components";
import { TextWithLabel as Text } from "@octopusdeploy/design-system-octopus-components";
import type { NewLibraryVariableSetResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { flushSync } from "react-dom";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import { required } from "~/components/form/Validators";
import InternalRedirect from "../../../../components/Navigation/InternalRedirect/InternalRedirect";
interface AddVariableSetDialogLayoutProps {
    spaceId: string;
}
interface AddVariableSetDialogLayoutState extends DataBaseComponentState {
    name: string;
    description: string;
    newVariableSetId?: string;
}
export class AddVariableSetDialogLayout extends DataBaseComponent<AddVariableSetDialogLayoutProps, AddVariableSetDialogLayoutState> {
    constructor(props: AddVariableSetDialogLayoutProps) {
        super(props);
        this.state = {
            name: "",
            description: "",
        };
    }
    render() {
        return (<SaveDialogLayout title="Add New Variable Set" busy={this.state.busy} errors={this.errors} onSaveClick={() => this.save()}>
                {this.state.newVariableSetId && <InternalRedirect to={links.variableSetPage.generateUrl({ spaceId: this.props.spaceId, variableSetId: this.state.newVariableSetId })}/>}
                <Text label="New variable set name" value={this.state.name} onChange={(name) => this.setState({ name })} validate={required("Please enter a variable set name")} autoFocus={true}/>
                <MarkdownEditor label="Variable set description" value={this.state.description} onChange={(description) => this.setState({ description })} restrictHeight={true}/>
            </SaveDialogLayout>);
    }
    private async save() {
        return this.doBusyTask(async () => {
            const libraryVariableSet: NewLibraryVariableSetResource = {
                Name: this.state.name,
                Description: this.state.description,
                VariableSetId: undefined!,
                ContentType: undefined!,
                Templates: undefined!,
                Id: undefined!,
                Links: undefined!,
            };
            const savedLibraryVariableSet = await repository.LibraryVariableSets.create(libraryVariableSet);
            flushSync(() => {
                this.setState({ newVariableSetId: savedLibraryVariableSet.Id });
            });
        });
    }
    static displayName = "AddVariableSetDialogLayout";
}
